import { useEffect, useState } from 'react'

import { authenticateWithCode, getAccessToken, setAccessToken } from '@driftt/web-auth'

export const useAuthFromCode = (authorizationCode: string | null): boolean => {
  const accessToken = getAccessToken()
  const shouldFetch = !accessToken && !!authorizationCode
  const [fetchingAuthCode, setFetchingAuthCode] = useState<boolean>(shouldFetch)

  useEffect(() => {
    if (!!authorizationCode && !accessToken) {
      const cb = async () => {
        await authenticateWithCode({ authorizationCode })
        setAccessToken({ token: getAccessToken() })
        setFetchingAuthCode(false)
      }
      setFetchingAuthCode(true)
      cb()
    }
  }, [accessToken, authorizationCode])

  return fetchingAuthCode
}
